import { render, staticRenderFns } from "./DedicatedSupport.vue?vue&type=template&id=e35d2bf0&"
import script from "./DedicatedSupport.vue?vue&type=script&lang=js&"
export * from "./DedicatedSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIBlobBackground: require('/opt/build/repo/components/UI/BlobBackground.vue').default})
